<div
  [ngClass]="{
    checkbox: true,
    'checkbox--required': required,
    'checkbox--disabled': disabled,
  }"
  (click)="onClick($event, cb, true)"
>
  <input
    #cb
    type="checkbox"
    [attr.id]="'checkbox-' + id"
    [checked]="checked"
    [attr.required]="required"
    [attr.name]="name"
    [disabled]="disabled"
    [value]="value"
    (change)="handleChange($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
  />
  <label [attr.for]="'checkbox-' + id" [ngClass]="{ 'checkbox--disabled': disabled }">
    {{ label }}
    <span class="checkbox__secondary-label f-size-xs f-color-light" *ngIf="secondaryLabel">
      {{ secondaryLabel }}
    </span>
  </label>
</div>
